module.exports = __webpack_public_path__ + "img/channel-order.276ae3e2.png";